import { useContext, useEffect, useState } from 'react';
import { GetResumen } from '../../data/Help';
import { DataContext } from '../../data/DataContext';
import { Tooltip } from '../controls/Tooltip';
const Step3 = () => {

    const { AutoNI, setAutoNI } = useContext(DataContext);
    const [detail, setDetail] = useState([] as Array<IRatesTable>);
    const [resumen, setResumen] = useState({} as IRatesResumen);


    useEffect(() => {

        console.log(AutoNI);
        let result = GetResumen(AutoNI);
        setDetail(result.coveragesDetail);
        setResumen(result);
        setAutoNI({ ...AutoNI, summary: result });
    }, [])

    return (
        <>
            <table className='table-autoni-cover mb-30'>
                <thead className='table-autoni-cover-h'>
                    <tr>
                        <th className='w50 text-left-autoni pl-10 pr-10'>
                            <div className='display-flex'>
                                Coberturas
                                <Tooltip id='idCoverage' text='Protección contratada para cubrir el bien ante siniestros' title='Coberturas' />
                            </div>
                        </th>
                        <th className='w20'>Suma Asegurada</th>
                        <th className='w20'>Prima</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        detail.map((coverage: IRatesTable) => {
                            return (
                                <>
                                    <tr>
                                        <td className='table-autoni-cover-txt1 pt-20 pb-20'>{coverage.name}</td>
                                        <td className='text-right-autoni pr-10'>{coverage.value}</td>
                                        <td className='text-right-autoni pr-10'>{coverage.insured}</td>
                                    </tr>
                                </>
                            );
                        })
                    }
                </tbody>
            </table>
            <table className='table-autoni-detail'>
                <thead>
                    <th className='pl-10'>
                        Resumen de prima
                    </th>
                </thead>
                <tbody>
                    <tr>
                        <td className='pl-10'>Prima neta</td>
                        <td className='text-right-autoni pr-10'>{resumen.bonusStr}</td>
                    </tr>
                    <tr>
                        <td className='pl-10'>Derecho de emisión</td>
                        <td className='text-right-autoni pr-10'>{resumen.rightEmissionsStr}</td>
                    </tr>
                    <tr>
                        <td className='pl-10'>Impuesto</td>
                        <td className='text-right-autoni pr-10'>{resumen.taxStr}</td>
                    </tr>
                    <tr>
                        <td colSpan={2}>
                            <div className='table-autoni-detail-tot'></div>
                        </td>
                    </tr>
                    <tr >
                        <td className='pl-10 table-autoni-detail-tot2'>Total</td>
                        <td className='text-right-autoni pr-10 table-autoni-detail-tot2'>{resumen.totalStr}</td>
                    </tr>
                </tbody>
            </table>
            <table className='table-autoni-detail mt-20'>
                <thead>
                    <th className='pl-10'>
                        Frecuencia de pago
                    </th>
                </thead>
                <tbody>
                    <tr>
                        <td className='pl-10'>Mensual</td>
                        <td className='text-right-autoni pr-10'>{resumen.bonusMonthly}</td>
                    </tr>
                    <tr>
                        <td className='pl-10'>Trimestral</td>
                        <td className='text-right-autoni pr-10'>{resumen.bonusQuarterly}</td>
                    </tr>
                    <tr>
                        <td className='pl-10'>Semestre</td>
                        <td className='text-right-autoni pr-10'>{resumen.bonusSemester}</td>
                    </tr>
                    <tr className=''>
                        <td className='pl-10 '>Anual</td>
                        <td className='text-right-autoni pr-10 '>{resumen.bonusAnnual}</td>
                    </tr>
                </tbody>
            </table>
        </>
    );
}

export { Step3 }